import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import * as S from './styles';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { MdArrowBack } from 'react-icons/md';
import AtendimentoBaseServices from '../../services/AtendimentoBase/AtendimentoBaseServices';
import secureStorage from '../../utils/SecureStorage';
import ModalCadastroAtendimento from '../../components/ModalCadastroAtendimento'; 
import { FaQuestionCircle } from 'react-icons/fa';
import ExibirWiki from '../../components/ExibirWiki/ExibirWiki';




const AtendimentoLista = () => {
  const [cadastros, setCadastros] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [selecionados, setSelecionados] = useState([]);
  const [agruparPor, setAgruparPor] = useState('cidade');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cadastroSelecionado, setCadastroSelecionado] = useState(null);
  const navigate = useNavigate();
  const [mostrarAjuda, setMostrarAjuda] = useState(false);
  

  useEffect(() => {
    carregarAtendimentos();
  }, []);

  const carregarAtendimentos = async () => {
    try {
      const registros = await AtendimentoBaseServices.getAtendimentobaseById();
      setCadastros(registros);
    } catch (err) {
      console.error("Erro ao carregar atendimentos:", err);
    }
  };

  const deletarSelecionados = async () => {
    for (const id of selecionados) {
      try {
        const realId = typeof id === 'object' && id.$oid ? id.$oid : id;
        await AtendimentoBaseServices.deleteVisita(realId);
      } catch (error) {
        console.error('Erro ao excluir:', error);
      }
    }
    setSelecionados([]);
    carregarAtendimentos();
  };
  

  const toggleSelecionado = (id) => {
    setSelecionados((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const abrirModalEdicao = (cadastro) => {
    const atendimentoFormatado = {
      ...cadastro,
      estabelecimento: cadastro.estabelecimento,
      clientes: cadastro.clientes.map((cli) => ({
        cliente: {
          _id: cli.id,
          nome: cli.nome,
          cpf_cnpj: cli.cpf_cnpj,
          endereco: cli.endereco,
          contato: cli.contato,
        },
        produtos: cli.produtos.map((p) => ({
          _id: p.id,
          gtin: p.gtin,
          descricao: p.descricao,
          marca: p.marca,
          thumbnail: p.thumbnail,
        }))
      }))
    };

    setCadastroSelecionado(atendimentoFormatado);
    setIsModalOpen(true);
  };

  const fecharModalEdicao = () => {
    setCadastroSelecionado(null);
    setIsModalOpen(false);
    carregarAtendimentos();
  };

  const atendimentosFiltrados = cadastros.filter((a) =>
    a.estabelecimento?.nome_fantasia?.toLowerCase().includes(filtro.toLowerCase())
  );

  const atendimentosAgrupados = atendimentosFiltrados.reduce((acc, atual) => {
    let chave;

    if (agruparPor === 'cidade') {
      chave = atual.estabelecimento?.endereco?.cidade || 'Sem cidade';
    } else if (agruparPor === 'nome') {
      const nome = atual.estabelecimento?.nome_fantasia || 'Sem nome';
      chave = nome.split(' ')[0].toUpperCase();
    }

    if (!acc[chave]) acc[chave] = [];
    acc[chave].push(atual);
    return acc;
  }, {});

  return (
    <>
      <Header />
      <div style={{
        position: 'fixed',
        top: 80,
        right: 20,
        zIndex: 1000,
        cursor: 'pointer'
      }}>
        <FaQuestionCircle
          size={28}
          color="#cf0505"
          title="Ajuda em vídeo"
          onClick={() => setMostrarAjuda(true)}
        />
      </div>
      {/* Exibe o modal com o vídeo ao clicar no ícone */}
      <ExibirWiki
        link='https://www.youtube.com/embed/aUFWH0v9GNw'
        isOpen={mostrarAjuda}
        onClose={() => setMostrarAjuda(false)}
      />
      <S.BackButton onClick={() => navigate('/Roteiros')}>
        <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} />
        Voltar
      </S.BackButton>
      <S.Container style={{ paddingBottom: '100px' }}>
        <div style={{ textAlign: 'center', margin: '40px 0 24px' }}>
          <S.Title>Cadastro de Roteiro Base</S.Title>
        </div>

        <S.TopActions>
          <button onClick={() => setAgruparPor('cidade')} disabled={agruparPor === 'cidade'}>
            Agrupar por Cidade
          </button>
          <button onClick={() => setAgruparPor('nome')} disabled={agruparPor === 'nome'}>
            Agrupar por Nome
          </button>
          <button onClick={() => {
            setCadastroSelecionado(null);
            setIsModalOpen(true);
          }}>
            Cadastrar Novo
          </button>
          <button onClick={deletarSelecionados} disabled={selecionados.length === 0}>
            Deletar Selecionados
          </button>
        </S.TopActions>

        <S.ActionInputWrapper>
          <input
            type="text"
            placeholder="Buscar por nome fantasia..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </S.ActionInputWrapper>

        {Object.keys(atendimentosAgrupados).length > 0 ? (
          <S.ScrollableTableArea>
            {Object.entries(atendimentosAgrupados).map(([chave, registros]) => (
              <div key={chave} style={{ marginBottom: '30px' }}>
                <h3 style={{ margin: '20px 0 10px' }}>{chave}</h3>
                <S.StyledTable>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Estabelecimento</th>
                      <th>Cidade</th>
                      <th>Bairro</th>
                      <th>Endereço</th>
                      <th>Clientes</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registros.map((a) => (
                      <tr key={a._id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selecionados.includes(a._id)}
                            onChange={() => toggleSelecionado(a._id)}
                          />
                        </td>
                        <td>{a.estabelecimento?.nome_fantasia || '---'}</td>
                        <td>{a.estabelecimento?.endereco?.cidade || '---'}</td>
                        <td>{a.estabelecimento?.endereco?.bairro || '---'}</td>
                        <td>
                          {a.estabelecimento?.endereco?.rua}, {a.estabelecimento?.endereco?.numero}
                        </td>
                        <td>{a.clientes?.map(c => c.nome).join(', ') || '---'}</td>
                        <td>
                          <S.EditButton onClick={() => abrirModalEdicao(a)}>
                            Editar
                          </S.EditButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </S.StyledTable>
              </div>
            ))}
          </S.ScrollableTableArea>
        ) : (
          <p style={{ textAlign: 'center', marginTop: '20px' }}>Nenhum atendimento encontrado.</p>
        )}
      </S.Container>

      {isModalOpen && (
        <ModalCadastroAtendimento
          isOpen={isModalOpen}
          onClose={fecharModalEdicao}
          atendimentoSelecionado={cadastroSelecionado}
          atualizarLista={carregarAtendimentos}
        />
      )}

      <Footer />
    </>
  );
};

export default AtendimentoLista;
